<template>
  <div class="doomyogalogin doomyoga-auth-container">
    <div class="h-100">
      <div class="row h-100 m-0">
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-12 my-auto">
          <div class="book-class-summary">
            <b-container class="p-0 pm-2">
              <b-card class="card-login my-1 py-0">
                <img
                  :src="getImgUrl('doom-yoga/Doomyoga-logo.png')"
                  class="d-block mx-auto loginIconImg auth-logo-dy mb-4"
                />
                <h2 class="welecomeH6 welecomeDYH6 mt-4 mb-3">CARD DETAILS</h2>

                <StripeForm client_name="DY"/>

                <div class="w-100 mt-2">
                  <img
                    :src="getImgUrl('doom-yoga/stripe-logo.png')"
                    class="d-block mx-auto stripeLogo auth-logo-dy mb-4"
                  />
                </div>
              </b-card>
            </b-container>
          </div>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-6 col-sm-12 my-auto">
          <div class="container" id="doomYogaImdDiv">
            <img
              class="img-fluid mx-auto"
              id="doomYogaLoginImg"
              src="@/assets/images/doom-yoga/doom-yoga-login-image2.png"
              alt="doomyoga Logo"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StripeForm from "@/components/Payment/StripeFormEvent";

export default {
  name: "DoOmYogaCustomerEventsBookSummary",
  components: { StripeForm },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
    };
  },
  mounted() {
    console.log("in book payment view");
    let event_date = window.sessionStorage.getItem("selected_date"),
      event_time = window.sessionStorage.getItem("selected_slot"),
      event_id = window.sessionStorage.getItem("selected_class");
    console.log(event_date, event_time, event_id);
  },
  methods: {
    getImgUrl(imgname) {
      // var images = require.context("@/assets/images/", false, /\.png$/);
      // return images("./" + imgname );

      return require("@/assets/images/" + imgname);
    },
    onSubmit() {
      console.log("submit stripe");
    },
  },
};
</script>

<style  scoped::v-deep>
@import "../../css/doom-yoga-fonts.css";
@import "../../css/doom-yoga-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Events/Payment.vue